import RequireModule from 'routes/components/RequireModule';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const BeyondBilling = withLazyFallback(() => import('components/practice/BeyondBilling'));
const CMS1500 = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/CMS1500/CMS1500')
);
const Eob = withLazyFallback(() => import('components/practice/BeyondBilling/ERA&EOB/EOB/Eob'));

const Era = withLazyFallback(() => import('components/practice/BeyondBilling/ERA&EOB/ERA/Era'));

const ViewEra = withLazyFallback(
  () => import('components/practice/BeyondBilling/ERA&EOB/ERA/components/ViewEra/ViewEra')
);
const NewClaims = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/NewClaims')
);
const DynamicAR = withLazyFallback(
  () => import('components/practice/BeyondBilling/DynamicAR/DynamicAR')
);
const DynamicInvoices = withLazyFallback(
  () => import('components/practice/BeyondBilling/ElectronicInvoicing/DynamicInvoices')
);
const ElectronicInvoicing = withLazyFallback(
  () => import('components/practice/BeyondBilling/ElectronicInvoicing/ElectronicInvoicing')
);
const ViewInternalInvoice = withLazyFallback(
  () =>
    import('components/practice/BeyondBilling/ElectronicInvoicing/components/ViewInternalInvoice')
);
const IncomeIQueue = withLazyFallback(
  () => import('components/practice/BeyondBilling/IncomeIQueue/IncomeIQueue')
);
const PatientLedger = withLazyFallback(
  () => import('components/practice/BeyondBilling/PatientLedger/PatientLedger')
);
const Payments = withLazyFallback(
  () => import('components/practice/BeyondBilling/Payments/Payments')
);
const BeyondBillingReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/BeyondBillingReports')
);
const CustomReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/CustomReports/CustomReports')
);
const FavoriteReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/FavoriteReports/FavoriteReports')
);
const StandardReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/StandardReports/StandardReports')
);
const Superbills = withLazyFallback(
  () => import('components/practice/BeyondBilling/Superbill/Superbills')
);
const ExternalPreview = withLazyFallback(
  () => import('components/practice/BeyondBilling/ElectronicInvoicing/components/ExternalPreview')
);
const BeyondBillingOverview = withLazyFallback(
  () => import('components/practice/BeyondBilling/Overview/Overview')
);

const Plans = withLazyFallback(() => import('components/practice/BeyondBilling/Plans/Plans'));
const AutoRecurring = withLazyFallback(
  () => import('components/practice/BeyondBilling/Plans/components/AutoRecurring/AutoRecurring')
);
const Installments = withLazyFallback(
  () => import('components/practice/BeyondBilling/Plans/components/Installments/Installments')
);

const PRACTICE_BEYOND_BILLING = [
  {
    path: 'beyond-billing',
    element: <BeyondBilling />,
    handle: { title: 'Beyond Billing' },
    children: [
      { path: '', element: <BeyondBillingOverview />, handle: { title: 'Overview' } },
      { path: 'income-i-queue', element: <IncomeIQueue />, handle: { title: 'Income I-Queue' } },
      {
        path: 'payments',
        element: <Payments />,
        handle: { title: 'Payments' },
        children: [{ path: 'era/:id', element: <ViewEra /> }]
      },
      {
        path: 'plans',
        element: (
          <RequireModule module="medipay.payment_suite.recurring_charges">
            <Plans />
          </RequireModule>
        ),
        children: [
          { path: 'auto-recurring', element: <AutoRecurring /> },
          { path: 'installments', element: <Installments /> }
        ]
      },
      {
        path: 'patient-ledger',
        element: <PatientLedger name="patient_ledger" />,
        handle: { title: 'Patient Ledger' }
      },
      {
        path: 'dynamic-ar',
        element: <DynamicAR />,
        handle: { title: 'Dynamic AR' },
        children: [{ path: ':type', element: <DynamicAR /> }]
      },
      {
        path: 'era',
        element: (
          <RequireModule module="billing.era_eob_posting">
            <Era />
          </RequireModule>
        ),
        handle: { title: 'ERA' },
        children: [{ path: ':id', element: <ViewEra /> }]
      },
      {
        path: 'eob',
        element: (
          <RequireModule module="billing.era_eob_posting">
            <Eob />
          </RequireModule>
        ),
        handle: { title: 'EOB' },
        children: [{ path: ':id', element: <ViewEra /> }]
      },
      {
        path: 'claims',
        element: (
          <RequireModule module="billing.claims">
            <NewClaims />
          </RequireModule>
        ),
        handle: { title: 'Claims' },
        children: [
          { path: ':id', element: <CMS1500 /> },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'superbills',
        element: (
          <RequireModule module="billing.superbills">
            <Superbills />
          </RequireModule>
        ),
        handle: { title: 'Superbills' },
        children: [
          { path: 'claim/:claimId', element: <CMS1500 /> },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'electronic-invoicing',
        element: <ElectronicInvoicing />,
        handle: { title: 'Electronic Invoices' },
        children: [
          {
            path: '',
            element: <DynamicInvoices />,
            children: [
              { index: true, element: <ExternalPreview /> },
              { path: ':invoiceId', element: <ViewInternalInvoice fromRoute /> }
            ]
          },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'reports',
        element: (
          <RequireModule module={['core.reporting_center', 'medipay.payment_suite']}>
            <BeyondBillingReports />
          </RequireModule>
        ),
        children: [
          {
            path: 'standard',
            element: <StandardReports />,
            handle: { title: 'Standard Reports' }
          },
          {
            path: 'favorite',
            element: <FavoriteReports />,
            handle: { title: 'Favorite Reports' }
          },
          { path: 'custom', element: <CustomReports />, handle: { title: 'Custom Reports' } }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PRACTICE_BEYOND_BILLING;
